<template>
  <div id="credit">
    <div class="row">
      <div class="reportSection">
        <section-heading>
          <div slot="title">Credit Information</div>
        </section-heading>
      </div>
      <template v-if="report.companyoverview.creditreport">
        <div class="row">
          <left-column :report="report"></left-column>
          <right-column :report="report"></right-column>
        </div>
        <div class="row">
          <county-court-judgements :report="report"></county-court-judgements>
        </div>
        <div class="sectionBreak row"></div>
      </template>

      <template v-else>
        <div class="well well-sm well-neutral">
          <table class="table-condensed">
            <tbody>
              <tr>
                <td width="50" style="text-align: center">
                  <i class="fas fa-exclamation-circle"></i>
                </td>
                <td>
                  <h4>Credit data not available</h4>
                  <p>
                    Your account does not give you access to this information, please contact
                    Ignition to find out more.
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import SectionHeading from '@/components/reports/components/SectionHeading';
import LeftColumn from '@/components/reports/sections/creditinformation/LeftColumn';
import RightColumn from '@/components/reports/sections/creditinformation/RightColumn';
import CountyCourtJudgements from '@/components/reports/panels/CountyCourtJudgements';

export default {
  components: {
    SectionHeading,
    LeftColumn,
    RightColumn,
    CountyCourtJudgements,
  },
  props: ['report', 'showDiff', 'diffData'],
};
</script>
